'use strict';

/**
 * Setup feature toggle functionality
 */
function navRowSlider() {
    $('.experience-commerce_layouts-navRow .mobile-swipe').slick({
        dots: false,
        arrows: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true
    });
}

$(document).ready(function () {
    if (window.matchMedia('(max-width: 48em)').matches) {
        navRowSlider();
    }
});

$(document).on('lazyloaded', function () {
    $('.experience-commerce_layouts-navBlock .nav-link picture').matchHeight();
    $('.experience-commerce_layouts-navBlock .nav-link').matchHeight();
});

$(window).smartresize(function () {
    if (window.matchMedia('(max-width: 48em)').matches) {
        if (!$('.experience-commerce_layouts-navRow .mobile-swipe').hasClass('slick-initialized')) {
            navRowSlider();
        }
    } else {
        if ($('.experience-commerce_layouts-navRow .mobile-swipe').hasClass('slick-initialized')) {
            $('.experience-commerce_layouts-navRow .mobile-swipe').slick('unslick');
        }
    }

    $('.experience-commerce_layouts-navBlock .nav-link picture').matchHeight();
    $('.experience-commerce_layouts-navBlock .nav-link').matchHeight();
});
